import { useLazyQuery } from '@apollo/client';
import { useAuth } from 'contexts/AuthContext';
import { database } from '../../firebase';
import { USER_DETAIL } from 'graph_ql/authentication/queries';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { LOCAL_STORAGE_KEY } from 'utils/constant';

export const UserDetailProvider = () => {
    const { currentUser } = useAuth();
    const userDetail = useSelector((state: RootState) => state.userDetail?.me || '');
    const [getUserFn] = useLazyQuery(USER_DETAIL, {
        onCompleted: () => {},
        context: {
            scope: 'private',
        },
        fetchPolicy: 'network-only',
    });
    useEffect(() => {
        if (currentUser?.uid) {
            const onValueChange = database.realtimeDatabase
                .ref('users')
                .child(currentUser?.uid)
                .child('lastUpdated')
                .on('value', async (snapshot) => {
                    const realTimeMessage = snapshot.val();
                    let prevLastUpdatedValue: string | number | null = localStorage.getItem(
                        LOCAL_STORAGE_KEY.USER_LAST_UPDATED_TIMESTAMP,
                    );
                    if (prevLastUpdatedValue) {
                        prevLastUpdatedValue = Number(prevLastUpdatedValue);
                    }
                    if (prevLastUpdatedValue !== realTimeMessage) {
                        localStorage.setItem(LOCAL_STORAGE_KEY.USER_LAST_UPDATED_TIMESTAMP, realTimeMessage);
                        getUserFn();
                    }
                });
            return () => {
                database.realtimeDatabase
                    .ref('users')
                    .child(currentUser?.uid)
                    .child('lastUpdated')
                    .off('value', onValueChange);
            };
        }
    }, [currentUser?.uid, getUserFn]);
    useEffect(() => {
        if (!userDetail) {
            getUserFn();
        }
    }, [getUserFn, userDetail]);

    return <></>;
};
